import script from "./logo-paedcompenda.vue?vue&type=script&lang=ts&setup=true"
export * from "./logo-paedcompenda.vue?vue&type=script&lang=ts&setup=true"

import "./logo-paedcompenda.vue?vue&type=style&index=0&id=c00a30f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c00a30f2"]])

export default __exports__